// Search
export const INE_CALENDAR_SEARCH_START_LOADING = "INE_CALENDAR_SEARCH_START_LOADING";
export const INE_CALENDAR_SEARCH_END_LOADING = "INE_CALENDAR_SEARCH_END_LOADING";
export const INE_CALENDAR_SEARCH_LOADED = "INE_CALENDAR_SEARCH_LOADED";
export const SET_INE_CALENDAR_FILTER = "SET_INE_CALENDAR_FILTER";
